import { get } from '../httpMethods';
import { ApiResponse } from '../../types/api';

export interface VisitTimelineEvent {
  id: string;
  visitId: string;
  patientId: string;
  eventType: string;
  eventTimestamp: string;
  performedById?: string;
  performedBy?: { name: string };
  sourceModule: string;
  description?: string;
  createdAt: string;
}

export const visitTimelineService = {
  getByVisit: (visitId: string): Promise<ApiResponse<VisitTimelineEvent[]>> => {
    return get<VisitTimelineEvent[]>(`/visit-timeline/visit/${visitId}`);
  },

  getByPatient: (patientId: string, page = 1, limit = 50): Promise<ApiResponse<VisitTimelineEvent[]>> => {
    return get<VisitTimelineEvent[]>(`/visit-timeline/patient/${patientId}?page=${page}&limit=${limit}`);
  },
};
